import { useEffect } from 'react';

const HUB_URL = import.meta.env.VITE_HUB_URL || 'https://my.theonestack.com';

export function Login() {
  useEffect(() => {
    // Redirect to Hub for centralized authentication
    window.location.href = `${HUB_URL}/login?redirect=aiplatform`;
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="w-full max-w-md p-8 text-center">
        <h1 className="text-2xl font-bold text-foreground">The One AI Platform</h1>
        <p className="text-muted-foreground mt-2">Redirecting to The One Hub for sign in...</p>
      </div>
    </div>
  );
}
